@if (formConfigError()) {
	<div>
		<md-header size="xs" variant="semibold">Form Configuration Error</md-header>
	</div>
	<div>Please contact support.</div>
} @else {
	<div class="content-header">
		<md-header size="xs" variant="semibold">Profile Information</md-header>

		<div class="profile-actions">
			<button md-button (click)="onCancel()" [disabled]="form.untouched || form.pristine">Cancel</button>
			<button md-button-brand (click)="onSave()" [disabled]="(init() && form.invalid) || profileUpdating()">Save</button>
		</div>
	</div>
	<span>
		Contact the <a href="https://help.languagebird.com/kb-tickets/new" target="_blank" class="help-center-link">LanguageBird Help Center</a> if you need to
		change information that cannot be edited.
	</span>

	<md-content-box class="profile-form" type="disabled" [formGroup]="form">
		@if (internalProfileUpdating() || !supportDataLoaded()) {
			<lb-loader></lb-loader>
		}
		@if (supportDataLoaded()) {
			<lb-profile-personal-info-box [profile]="internalProfile()" [form]="form" [formDisabled]="formDisabled()"></lb-profile-personal-info-box>

			<lb-profile-contact-info-box
				[profile]="internalProfile()"
				[form]="form"
				[isLearner]="isLearner()"
				[formDisabled]="formDisabled()"
				[isGuest]="isGuest()"
				[isAdmin]="isAdmin()"
				[isSelf]="isSelf()"
			></lb-profile-contact-info-box>

			@if (isLearner() && !isGuest()) {
				<lb-profile-education-info-box [profile]="internalProfile()" [form]="form" [formDisabled]="formDisabled()"></lb-profile-education-info-box>
			}

			@if (!isAdmin()) {
				<lb-profile-location-info-box [profile]="internalProfile()" [form]="form" [formDisabled]="formDisabled()"></lb-profile-location-info-box>
			}

			@if (isInstructor()) {
				<lb-profile-notes-info-box [profile]="internalProfile()" [form]="form" [formDisabled]="formDisabled()"></lb-profile-notes-info-box>
			}

			<lb-calendar-advanced-sync></lb-calendar-advanced-sync>
		}
	</md-content-box>
}
